import { operatorsMap, SpreadsheetColumnsService, TableFilterColumns } from './../../../@core/utils/spreadsheet-columns.service';
import { InitiativesService } from './../../../@core/utils/initiatives.service';
import { InitiativesChangesService } from './../../../@core/utils/initiatives-changes.service';
import { InflationService } from './../../../@core/utils/inflation.service';
import { Component, EventEmitter, inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { NbDialogService, NbCardModule } from '@nebular/theme';
import { RightPanelDialogService } from '../../../@core/utils/right-panel-dialog.service';
import { TranslateService } from '@ngx-translate/core';
import { GridOptions } from 'ag-grid-community';
import { combineLatest, forkJoin, Observable, of } from 'rxjs';
import { debounceTime, filter, finalize, first, map, switchMap, tap } from 'rxjs/operators';
import { KPI } from '../../../@core/api';
import {
  PerimetersService,
  SpreadsheetColumnsInitiativesService,
  YearsService,
  UtilsService,
  QuickFiltersService,
  InvestmentScenariiService,
  ScopeService,
  ChartsService,
  ConfigService,
  UsersService,
  InvestmentStatusesService,
  InvestmentsService,
} from '../../../@core/utils';
import {
  AG_GRID_INITIATIVE_FILTERS,
  INITIATIVE_FILTER_KEY_PREFIX,
  TABLE_FILTER_ICON,
} from '../../../@core/utils/constants';
import { I18nService } from './../../../@core/utils/i18n.service';
import { EvolutionRendererComponent } from '../ag-grid-renderers/evolution-renderer.component';
import { idMapToArray } from '../../../@core/utils/scope.service';
import { AgGridBaseComponent } from '../ag-grid-base/ag-grid-base.component';
import { agIconLoadingTemplate } from '../circular-spinner/circular-spinner';
import * as R from 'ramda';
import { BasicDialogComponent } from '../basic-dialog/basic-dialog.component';
import { AgGridAngular } from 'ag-grid-angular';
import { InitiativeFormComponent } from '../side-forms/initiative-form/initiative-form.component';
import { RowNode } from 'ag-grid-community';
import { DialogWithCheckboxOptionComponent } from '../dialog-with-checkbox-option/dialog-with-checkbox-option.component';

@Component({
    selector: 'app-ag-grid-initiative',
    templateUrl: './ag-grid-initiative.component.html',
    styleUrls: ['./ag-grid-initiative.component.scss'],
    standalone: true,
    imports: [
    NbCardModule,
    
    AgGridAngular,
],
})
export class AgGridInitiativeComponent extends AgGridBaseComponent implements OnInit, OnChanges, OnDestroy {
  constructor(
    protected baseSpreadsheetColumnsService: SpreadsheetColumnsService,
    protected quickFiltersService: QuickFiltersService,
    protected route: ActivatedRoute,
    private translate: TranslateService,
    private spreadsheetColumnsService: SpreadsheetColumnsInitiativesService,
    private perimetersService: PerimetersService,
    private yearsService: YearsService,
    public i18n: I18nService,
    private dialogService: NbDialogService,
    private initiativesChangesService: InitiativesChangesService,
    private initiativesService: InitiativesService,
    private inflationService: InflationService,
    public utilsService: UtilsService,
    private investmentScenariiService: InvestmentScenariiService,
    private scopeService: ScopeService,
    private chartsService: ChartsService,
    private config: ConfigService,
    private usersService: UsersService,
    private investmentsService: InvestmentsService,
    private rightPanelDialogService: RightPanelDialogService,
  ) {
    super(baseSpreadsheetColumnsService, quickFiltersService, route);
  }

  protected spreadsheetType: KPI.SpreadsheetType = 'initiative';

  @Input() public inputFilters: any;
  @Input() public inputColumns: string[];
  @Input() public inputScenario: KPI.InvestmentScenario;
  @Input() public showScenarii: boolean = false;
  @Input() public project: KPI.Project;
  @Input() public isFidjiAct: boolean = false;
  @Output() public filtersNb = new EventEmitter<number>();
  @Output() public savingsSummary = new EventEmitter<KPI.SavingsSummary>();

  private investmentStatusesService = inject(InvestmentStatusesService);

  private filtersLocalStorageKey = AG_GRID_INITIATIVE_FILTERS;
  private filterKeyPrefix = INITIATIVE_FILTER_KEY_PREFIX;

  private _loading: boolean = false;
  get loading(): boolean { return this._loading; }
  set loading(val: boolean) {
    this._loading = val;
    if (val) {
      this.gridApi?.showLoadingOverlay();
    } else {
      this.gridApi?.hideOverlay();
    }
  }
  public notationsLoading: boolean = false;
  public gridOptions: GridOptions = {};
  public title: string;
  public customerConfig: KPI.CustomerConfig = null;
  private lastUpdateFromBackend: number;
  private loadingColumnsAndFilters = true; // Flag meaning it's the first grid loading
  private finishedFirstFiltering = false;
  private userOpenedFilter: boolean = false;
  private noDataSentence: string = '';
  private initiativeStatuses: KPI.InitiativeStatus[] = [];
  private investmentStatuses: KPI.InvestmentStatus[] = [];
  private scenarii: KPI.InvestmentScenario[] = [];
  public canAccessAudit: boolean;
  private permissions: KPI.PerimeterPermission[] = [];
  private allowedTransitions: KPI.AllowedStatusTransition[] = [];
  private newInitiative: KPI.Initiative = null;

  ngOnInit() {
    this.subscriptions.push(
      this.investmentStatusesService.getAllowedTransitionsStatus().pipe(first()).subscribe((allowedTransitions) => {
        this.allowedTransitions = allowedTransitions;
      }),
      this.investmentScenariiService.selectedScenarii$.pipe(
        map((scenarii) => scenarii.filter((s) => !!s))
      ).subscribe((scenarii) => {
        this.scenarii = scenarii;
      }),
      this.config.customerConfig$.subscribe((conf) => {
        this.canAccessAudit = conf.can_access_audit_app;
        this.customerConfig = conf;
      }),
      this.usersService.currentUserPerimeterPermissions$.subscribe((permissions) => this.permissions = permissions),
      this.initiativesChangesService.pendingChangesNumber$.subscribe((pendingChangesNumber) => {
        if (pendingChangesNumber > 0) {
          this.loading = true;
        } else if (!this.loadingColumnsAndFilters) {
          this.gridApi.refreshServerSide();
          // 800 ms before ending the loading, in order to let time to the spreadsheet to reload
          // the data after an update
          setTimeout(() => {
            this.loading = false;
          }, 800);
        }
      }),
      combineLatest([
        this.chartsService._capexHasChanged$,
        this.chartsService._energyHasChanged$,
      ]).pipe(
        filter(() => !this.loadingColumnsAndFilters)
      ).subscribe(() => {
        this.gridApi?.refreshServerSide();
      }),
      this.translate.get('pages.common.ag-grid.no_initiative_found').subscribe((noDataSentence) =>
        this.noDataSentence = noDataSentence,
      ),
      this.baseSpreadsheetColumnsService.deleteInitiativeFilters$.subscribe(
        (deleteFilters) => {
          if (deleteFilters && this.gridApi) {
            Object.keys(this.gridApi.getFilterModel()).map((k) => {
              this.gridApi.destroyFilter(k);
            });
            this.userOpenedFilter = true;
            this.gridApi.onFilterChanged();
            this.gridApi.closeToolPanel();
            localStorage.setItem(
              this.filtersLocalStorageKey,
              JSON.stringify({}),
            );
          }
        },
      ),
      this.baseSpreadsheetColumnsService.openInitiativeFilters$.subscribe((openFilters) => {
        if (openFilters && this.gridApi) {
          this.gridApi.openToolPanel('columns');
        } else if (!openFilters && this.gridApi) {
          this.gridApi.closeToolPanel();
        }
      }),
      combineLatest([
        this.initiativesService.initiativeStatuses$,
        this.scopeService.investmentStatuses$.pipe(idMapToArray()),
      ]).subscribe(([initiativeStatuses, investmentStatuses]) => {
        this.initiativeStatuses = initiativeStatuses;
        this.investmentStatuses = investmentStatuses;
      })
    );

    this.gridOptions = {
      ...this.gridOptions,
      rowModelType: 'serverSide',
      serverSideDatasource: this.serverSideDatasource(),
      loading: false,
      overlayLoadingTemplate: agIconLoadingTemplate,
      blockLoadDebounceMillis: 100,
      cacheBlockSize: 100,
      context: this,
      rowHeight: 28,
      rowBuffer: 10, // Draw 10 rows above and below the visible rows (Performance)
      allowDragFromColumnsToolPanel: true, // Allow user to move columns from panel
      cellSelection: {
        suppressMultiRanges: true,
      },
      rowSelection: 'multiple', // Enable to select the entire row instead of a cell
      getRowId: params => params.data?.initiative_id?.toString(),
      suppressPropertyNamesCheck: true,
      columnMenu: 'new',
      components: {
        evolutionRenderer: EvolutionRendererComponent,
      },
      icons: {
        columnGroupOpened: '<i class="ms-2 far fa-minus"/>',
        columnGroupClosed: '<i class="ms-2 far fa-plus"/>',
        filter: TABLE_FILTER_ICON,
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        editable: false,
        filter: true,
        wrapHeaderText: true,
        autoHeaderHeight: true,
        suppressMovable: false,
        menuTabs: [],
        suppressHeaderMenuButton: true,
        enableCellChangeFlash: true,
        cellStyle: (params) => {
          if (params.column?.isFilterActive()) {
            return { color: '#ff6c6c' }
          }
          return {}
        },
        filterParams: {
          excelMode: 'windows',
          values: (params) => {
            if (params && params.colDef && params.colDef.field) {
              this.subscriptions.push(
                this.perimetersService.perimeters$
                  .pipe(
                    switchMap((perimeters) => {
                      const { api } = params;
                      const fullFilterModel = api.getFilterModel() || {};
                      const currentColumnField = params.colDef.field;
                      const colId = params.colDef.availableFilterField || currentColumnField;
                      
                      const filterModelWithoutCurrentColumn = { ...fullFilterModel };
                      if (currentColumnField && filterModelWithoutCurrentColumn[currentColumnField]) {
                        delete filterModelWithoutCurrentColumn[currentColumnField];
                      }
                      if (colId && colId !== currentColumnField && filterModelWithoutCurrentColumn[colId]) {
                        delete filterModelWithoutCurrentColumn[colId];
                      }
                      
                      const includeSelf =
                        (params.colDef.field || '').startsWith('initiative_status_scenario_');
                      return this.quickFiltersService.getAvailableFilterValues(
                        colId,
                        {
                          buildings: PerimetersService.getBuildingsIds(perimeters),
                          filterModel: filterModelWithoutCurrentColumn,
                          table: 'Initiative',
                        },
                        {
                          includeSelfFilter: includeSelf,
                        },
                      );
                    }),
                  )
                  .subscribe((res) => {
                    const values = res as any[];
                    params.success(params.colDef.notNull ? [...values] : [null, ...values]);
                  }),
              );
            }
          },
          // Disable ag-grid's default filter values sorting
          comparator: (_a, _b) => { },
        },
      },
      sideBar: !this.isFidjiAct
        ? {
          toolPanels: [
            {
              id: 'columns',
              labelDefault: this.translate.instant(
                'pages.common.ag-grid.columns',
              ),
              labelKey: 'columns',
              iconKey: 'columns',
              toolPanel: 'agColumnsToolPanel',
              // Hide every other tools
              toolPanelParams: {
                suppressRowGroups: true,
                suppressValues: true,
                suppressPivots: true,
                suppressPivotMode: true,
              },
            },
            {
              id: 'filters',
              labelDefault: this.translate.instant(
                'pages.common.ag-grid.filters',
              ),
              labelKey: 'filters',
              iconKey: 'filter',
              toolPanel: 'agFiltersToolPanel',
            },
          ],
          position: 'right', // Can set the side bar on the left or on the right
          // Set this to open the sidebar by default on columns panel
          // defaultToolPanel: 'columns',
        } : null,
      columnDefs: [], // Columns definition (Set it later)
      animateRows: true, // Row animations (when expanding)
      // Always show the column menus
      suppressMenuHide: true,
      groupHeaderHeight: 32, // Show group only when scenarii are displayed
      tooltipShowDelay: 0,
      // Restrict aggregations some functions (sum in an ag-grid native one)
      onGridReady: (params) => {
        this.gridApi = params.api;
        let colsAvailableFilterKeyMap: any = {};
        let colsThatNeedFilterValues = [];
        let cachedFilterModel: any = null;
        this.subscriptions.push(
          // Load investments data if on the PPA or single-page investments page
          (
            this.isFidjiAct
            ? this.spreadsheetColumnsService.getFidjiActInitiativeColumns()
            : this.spreadsheetColumnsService.getAgGridInitiativeColumns(this.showScenarii, this.inputScenario)
          ).pipe(
            tap((cols) => {
              cols.map((colGrp) =>
                colGrp.children?.map((col: KPI.CustomColDef) => {
                  colsAvailableFilterKeyMap[col.field] = col.availableFilterField || col.field;
                  if (col.field === 'initiative_label' || 
                      col.field === 'label' || 
                      col.headerName === 'Label') {
                    col.enableCellChangeFlash = false;
                  }
                }),
              );
              // Load columns
              this.gridApi.setGridOption('columnDefs', cols);
              this.restoreState();
              // @ts-ignore
              this.gridApi.getToolPanelInstance('columns')?.collapseColumnGroups();
            }),
            switchMap(() => this.isUrlParamsFilters()),
            switchMap((isUrlParamsFilters) => {
              if (isUrlParamsFilters) {
                cachedFilterModel = null;
                return this.applyURLParamsFilters().pipe(
                  tap((cols: TableFilterColumns[]) => colsThatNeedFilterValues.push(...cols))
                );
              } else if (!this.isInputFilter()) {
                cachedFilterModel = this.getCachedFilterModel();
                colsThatNeedFilterValues = Object.keys(cachedFilterModel);
              }
              return of([]);
            }),
            switchMap(() => this.applyInputFilters()),
            tap((cols: TableFilterColumns[]) => colsThatNeedFilterValues.push(...cols)),
            switchMap(() => this.applyQuickFilters()),
            tap((cols: TableFilterColumns[]) => colsThatNeedFilterValues.push(...cols)),
            map((quickFilterCols) => !!quickFilterCols?.length),
            switchMap((isQuickFiltered) => {
              this.isQuickFiltered = isQuickFiltered;
              if (colsThatNeedFilterValues?.length) {
                return this.perimetersService.perimeters$.pipe(
                  switchMap((perimeters) => {
                    // Make sure all the filter values are pre-loaded before applying the filters
                    return combineLatest([
                      ...colsThatNeedFilterValues.map((colId) =>
                        this.quickFiltersService.getAvailableFilterValues(
                          colsAvailableFilterKeyMap[colId] || colId,
                          {
                            buildings: PerimetersService.getBuildingsIds(perimeters),
                            ...{ filterModel: this.gridApi.getFilterModel() },
                            table: 'Initiative',
                          },
                        ),
                      ),
                    ]);
                  }));
              } else {
                return of([]);
              }
            }),
            debounceTime(500),
          ).subscribe(() => {
            if (cachedFilterModel && Object.keys(cachedFilterModel).length) {
              this.applyCachedFilterModel(cachedFilterModel);
              this.filtersNb.emit(Object.keys(cachedFilterModel).length);
            }
            
            this.applySortsFromUrl();
            this.finishedFirstFiltering = true;
            this.urlParamsApplied = true;
            this.inputFiltersApplied = true;
            this.gridApi?.onFilterChanged();
            this.gridApi?.refreshServerSide();
          }),
        );
      },
      // Hook executed after first data set
      onFirstDataRendered: () => {
        this.loadingColumnsAndFilters = false; // End the first loading

        // Move the row number column while it's hidden, then show it
        // This must be done here, as the row number column is provided after the
        // grouping column one, in order to have it first in the table
        this.gridApi.moveColumns(['row_nb'], 0);
        this.gridApi.setColumnsVisible(['row_nb'], true);

        // Force these columns to be display at the start of the table
        if (this.gridApi && this.inputColumns?.length) {
          setTimeout(() => {
            this.gridApi.moveColumns(this.inputColumns, 2);
            this.gridApi.setColumnsVisible(this.inputColumns, true);
          }, 100);
        }
      },
      // Hook executed after each data update
      onRowDataUpdated: () => {
        if (this.gridApi) {
          this.gridApi.moveColumns(['row_nb'], 0);
          this.gridApi.setColumnsVisible(['row_nb'], true);
        }
      },
      onFilterOpened: (event) => {
        // This is a hack to check if the user has opened at least one filter in order
        // to differenciate filter changes from user and the ones from the code itself
        if (event.source !== 'NO_UI') {
          this.userOpenedFilter = true;
        }
      },
      onFilterChanged: () => {
        if (this.gridApi) {
          // Retrieve current filters model
          const filterModel = this.gridApi.getFilterModel();
          const filtersNb = Object.keys(filterModel).length;
          this.filtersNb.emit(filtersNb);
          if (!this.loadingColumnsAndFilters) {
            // Check it's not the first loading
            if (this.userOpenedFilter || this.isQuickFiltered) {
              this.route.queryParams.subscribe((params) => {
                // Retrieve the filter keys from URL parameters
                const filterKeys = Object.keys(params).filter((key) =>
                  key.startsWith(this.filterKeyPrefix),
                );
                if ((!filterKeys || !filterKeys.length)) {
                  // Save filters model in cache
                  localStorage.setItem(
                    this.filtersLocalStorageKey,
                    JSON.stringify(filterModel),
                  );
                }
              });
            }
          }
          this.quickFiltersService.setFiltersFromSpreadsheet('initiative', filterModel);
        }
      },
      onStateUpdated: () => {
        this.saveState();
      },
      onColumnGroupOpened: () => {
        this.saveState();
      },
      onColumnVisible: () => {
        this.gridApi.moveColumns(['row_nb'], 0);
      },
      onCellDoubleClicked: (params) => {
        if (params.data?.initiative_id > 0 ) {
          this.openActionForm(params.data.initiative_id);
        }
      },
      getContextMenuItems: (params) => {
        if (!params.node || !params.node.data || !params.node.data.initiative_id || params.node.data.initiative_id <= 0 || params.node.data.id === 0) {
          return [];
        }
        return this.buildContextMenu();
      },
    };
    
    (this.gridOptions as any).cellFlashDuration = 2000; 
    (this.gridOptions as any).cellFadeDuration = 500;
    
    this.subscriptions.push(
      this.spreadsheetColumnsService.getAgGridTranslations().subscribe((agGridTranslations) => {
        this.gridOptions.localeText = agGridTranslations;
      }),
      this.initiativesService.newInitiative$.subscribe(initiative => {
        this.newInitiative = initiative;
      }),
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['inputFilters'] || changes['inputScenario']) {
      if (this.gridApi && !this.loadingColumnsAndFilters) {
        this.gridApi.refreshServerSide();
      }
    }
  }

  private updateSummary(
    savings: number,
    totalInitiatives: number,
    co2Savings: number,
    actionsBudget: number
  ): void {
    this.savingsSummary.emit({
      savings,
      totalInitiatives,
      co2Savings,
      actionsBudget
    });
  }

  private applyURLParamsFilters(): Observable<string[]> {
    return combineLatest([
      this.route.queryParams,
      this.investmentScenariiService.mainScenario$,
    ]).pipe(
      map(([params, scenario]) => {
        const colsThatNeedFilterValues = [];
        // Retrieve the filter keys from URL parameters
        const filterKeys = Object.keys(params).filter((key) =>
          key.startsWith(this.filterKeyPrefix),
        );
        const statusFilters: string[] = [];
        filterKeys.forEach((filterKey) => {
          // Get the column name from the URL param key
          let column = filterKey.substring(this.filterKeyPrefix.length);

          // Split the values from URL param
          let values = [];
          if (params[filterKey].includes('","')) {
            values = params[filterKey].split('","');
          } else {
            values = params[filterKey].split(',');
          }

          // Remove the (") from the value if any exists at the beginning or the end
          values = values.map((value) => {
            if (value.indexOf('"') === 0) {
              value = value.substring(1);
              if (value.indexOf('"') === value.length - 1) {
                return value.substring(0, value.length - 1);
              }
              return value;
            } else if (value.indexOf('"') === value.length - 1) {
              return value.substring(0, value.length - 2);
            }
            return value;
          });

          if (
            [
              'theoretical_savings_first_year',
              'theoretical_savings_full_year',
              'greenhouse_gas_savings_full_year',
            ].includes(column)
          ) {
            const operator = values[0].split(' ')[0];
            const value = values[0].split(' ')[1];

            // Get the filter instance of the column
            this.gridApi.getColumnFilterInstance(column).then((filterInstance) => {
              if (filterInstance) {
                let model = {};
                if (operatorsMap[operator] === 'inRange') {
                  model = {
                    filter: Number(value.split('-')[0]) - 1,
                    filterTo: Number(value.split('-')[1]) + 1,
                    filterType: 'number',
                    type: operatorsMap[operator],
                  };
                } else {
                  model = {
                    filter: value,
                    filterType: 'number',
                    type: operatorsMap[operator],
                  };
                }
                filterInstance.setModel(model);
              }
            });
          } else if (['hypothesis', 'cancelled', 'completed', 'to_be_specified'].includes(column)) {
            statusFilters.push(column)
            const booleanMap = {
              true: true,
              false: false,
            };

            const statuses = this.initiativeStatuses
              .filter((s) => statusFilters.every((filter) =>
                s[filter] === booleanMap[values[0]]
              ))
              .map((s) => s.id.toString());
            column = `initiative_status_scenario_${scenario.id}`
            this.gridApi.getColumnFilterInstance(column).then((filterInstance) => {
              if (filterInstance) {
                // Apply the set of values as a filter to the column
                filterInstance.setModel({
                  filterType: 'set',
                  values: statuses,
                });
              }
            });
          } else {
            if (column === 'savings_start_year') {
              column = `savings_start_year_scenario_${scenario.id}`
            }
            // Get the filter instance of the column
            this.gridApi.getColumnFilterInstance(column).then((filterInstance) => {
              if (filterInstance) {
                // Apply the set of values as a filter to the column
                filterInstance.setModel({
                  filterType: 'set',
                  values: values,
                });
              }
            });
          }
          colsThatNeedFilterValues.push(column);
        });

        // If there is a scenario parameter, hide the initiative status column
        if (params.scenario_id) {
          this.gridApi.setColumnsVisible(['initiative_status'], false);
        }
        return colsThatNeedFilterValues;
      })
    );
  }

  private isInputFilter(): boolean {
    return !!(this.inputFilters && Object.keys(this.inputFilters)?.length);
  }

  /**
   * Used to apply filters from Input (Example: displaying the table in a dialog)
   * In this case there Shouldn't be any filters in the URL
   */
  private applyInputFilters(): Observable<string[]> {
    const colsThatNeedFilterValues = [];
    if (this.isInputFilter()) {
      const inputFilterKeys = Object.keys(this.inputFilters);
      inputFilterKeys.map((column) => {
        const values = this.inputFilters[column].map((v) => v.toString());

        this.gridApi.getColumnFilterInstance(column).then((filterInstance) => {
          if (
            [
              'theoretical_savings_first_year',
              'theoretical_savings_full_year',
              'greenhouse_gas_savings_full_year',
            ].includes(column)
          ) {
            const operator = values[0].split(' ')[0];
            const value = values[0].split(' ')[1];

            // Get the filter instance of the column
            let model = {};
            if (operatorsMap[operator] === 'inRange') {
              model = {
                filter: Number(value.split('-')[0]) - 1,
                filterTo: Number(value.split('-')[1]) + 1,
                filterType: 'number',
                type: operatorsMap[operator],
              };
            } else {
              model = {
                filter: value,
                filterType: 'number',
                type: operatorsMap[operator],
              };
            }
            filterInstance.setModel(model);
          } else {
            // Apply the set of values as a filter to the column
            filterInstance.setModel({
              filterType: 'set',
              values: values,
            });
          }
        });
        colsThatNeedFilterValues.push(column);
      });
    }
    return of(colsThatNeedFilterValues);
  }

  private serverSideDatasource() {
    return {
      getRows: (params) => {
        this.loading = true;
        this.subscriptions.push(
          combineLatest([
            this.perimetersService.perimeters$,
            this.yearsToUse$,
            this.inflationService.selectedInflationHypothesis$,
          ])
            .pipe(
              switchMap(([perimeters, [start_year, end_year], inflationHypothesis]) => {
                this.loading = true;
                if (this.finishedFirstFiltering) {
                  const gridFilterModel = params.request.filterModel || {};
                  
                  let cachedFilterModel = {};
                  if (Object.keys(gridFilterModel).length === 0 && !this.isInputFilter()) {
                    cachedFilterModel = this.getCachedFilterModel();
                  }
                  
                  const filterModel = Object.keys(gridFilterModel).length > 0 
                    ? gridFilterModel 
                    : { ...cachedFilterModel };
                  
                  const queryParams = {
                    ...params.request,
                    filterModel: filterModel,
                    perimeters: PerimetersService.getAllPerimetersIds(perimeters),
                  }

                  queryParams['start_year'] = start_year;
                  queryParams['end_year'] = end_year;
                  queryParams['sortModel'].push({
                    sort: 'desc',
                    colId: 'initiative_id'
                  });

                  if (inflationHypothesis) {
                    queryParams['inflation_hypothesis'] = inflationHypothesis.id;
                  }
                  return this.spreadsheetColumnsService.getInitiativesData(queryParams);
                } else {
                  return of({
                    lastRow: 0,
                    rowCount: 0,
                    rowData: [{
                      initiative_label: this.noDataSentence,
                      id: 0,
                    }],
                    rowMax: 0,
                    co2Savings: 0,
                  });
                }
              }),
            )
            .subscribe({
              next: (data) => {
                this.updateSummary(
                  data['totalSavings'],
                  data['rowCount'],
                  data['co2Savings'],
                  data['actionsBudget'],
                );
                params.success(data);
                const now = new Date().getTime();
                if (!this.lastUpdateFromBackend || this.lastUpdateFromBackend < now) {
                  this.lastUpdateFromBackend = now;
                }
                this.loading = false;

                if (this.project) {
                  this.initiativesService.relevantEnergyTypes$.pipe(first()).subscribe((energyTypes) => {

                    const unitSumRow = {
                      initiative_id: -1,
                      initiative_label: this.translate.instant('Sum of unit gains'),
                      gain_all: data.rowData.reduce((acc, row) => acc + row.gain_all, 0),
                      greenhouse_gas_savings_full_year: data.rowData.reduce((acc, row) => acc + row.greenhouse_gas_savings_full_year, 0),
                    };

                    const globalProjectRow = {
                      initiative_id: -2,
                      initiative_label: this.translate.instant('Global gain of bouquet of works'),
                      gain_all: this.project.gains.reduce((acc, gain) =>
                        acc += gain.theoretical_savings_full_year || 0,
                        0
                      ),
                      greenhouse_gas_savings_full_year: this.project.gains.reduce((acc, gain) =>
                        acc += gain.theoretical_greenhouse_gas_savings_full_year || 0,
                        0
                      ),
                    };

                    energyTypes.map((energyType) => {
                      globalProjectRow[`gain_${energyType.id}`] = this.project.gains.find((gain) =>
                        gain.energy_type === energyType.id,
                      )?.theoretical_savings_full_year;
                    });

                    this.project.instances.map((instance) => {
                      const instanceData = {
                        [`initiative_status_scenario_${instance.scenario.id}`]: instance.status.id,
                        [`savings_start_year_scenario_${instance.scenario.id}`]: new Date(instance.savings_start_at).getFullYear(),
                      }

                      Object.entries(instanceData).map(([key, value]) => {
                        unitSumRow[key] = value;
                        globalProjectRow[key] = value;
                      });
                    });

                    this.gridApi?.setGridOption('pinnedBottomRowData', [unitSumRow, globalProjectRow]);
                  });
                } else {
                  this.gridApi?.setGridOption('pinnedBottomRowData', []);
                }
                this.selectNewInitiativeRow();
              },
              error: (error) => {
                console.error(error);
                params.fail();
              },
            }),
        );
      },
    };
  }

  private getSelectedRows(): RowNode<any>[] {
      const selectedRanges = this.gridApi.getCellRanges();
      const selectedNodes: Set<RowNode<any>> = new Set();

      if (selectedRanges?.length) {
        selectedRanges.forEach(range => {
          const startIndex = range.startRow?.rowIndex;
          const endIndex = range.endRow?.rowIndex;

          if (startIndex != null && endIndex != null) {
            const from = Math.min(startIndex, endIndex);
            const to = Math.max(startIndex, endIndex);

            for (let i = from; i <= to; i++) {
              const node = this.gridApi.getDisplayedRowAtIndex(i);
              if (node) {
                selectedNodes.add(node as unknown as RowNode<any>);
              }
            }
          }
        });
      }

      return Array.from(selectedNodes);
    }

  /**
   * Build the cells context menu
   */
  protected buildContextMenu() {

    const contextMenu = []; // Initialize context menu
    this.gridApi.deselectAll();

    const scenarii: KPI.InvestmentScenario[] = this.inputScenario
      ? [this.inputScenario]
      : this.scenarii.filter((scenario) => this.showScenarii || scenario.is_main);

    /**
     * Get data from selected rows
     */
    const rowNodes = this.getSelectedRows();

    const areSelectedRows = rowNodes.length > 0;
    // True if single select - False if multiple (+ check if row is not a group)
    const isSingleSelect = rowNodes.length === 1;
    // Get investment ids from rows selected, and remove duplicate ids
    const initiativeIds = rowNodes.filter((rowNode) =>
      rowNode?.data?.initiative_id
    ).map((rowNode) => Number(rowNode.data.initiative_id));

    // Has user permission ?
    // We consider that the user doesn't have permission if at least one site in the selection
    // is read_only
    const siteIds = rowNodes.map(node => node.data.site);
    const readOnlyPermissions = this.permissions.filter(
      perm => siteIds.includes(perm.perimeter) && perm.read_only
    );
    const readOnly = readOnlyPermissions?.length > 0;

    let blockedStatus: boolean = false;
    if (isSingleSelect && scenarii.length > 0) {
      blockedStatus = scenarii.some((scenario) => {
        const currentStatusId = rowNodes[0].data[`initiative_status_scenario_${scenario.id}`];
        const currentStatus = this.initiativeStatuses.find(status => status.id === currentStatusId);
        return !(currentStatus.hypothesis || currentStatus.is_request || currentStatus.is_cancelled);
      });
    }

    if (areSelectedRows) {
        /**
         * Change initiative status
         */
        contextMenu.push({
          name: isSingleSelect
            ? this.translate.instant('Change action status')
            : this.translate.instant('Change actions status'),
          icon: '<i class="fa-light fa-user-check fa-lg"></i>',
          disabled: !this.customerConfig?.is_show_edit || readOnly,
          subMenu: scenarii.map((scenario) => {

            // find the instances of initiatives for the current scenario
            const statusesFromInstanceInScenario = rowNodes.map(rn => rn?.data?.instances.find(inc => inc.scenario === scenario.id)).map(data => data.status),
            // if user selected multiple initiatives with different statuses
            isSelectedMultipleStatus = new Set(statusesFromInstanceInScenario).size > 1;

            const hasPlannedProject = rowNodes.some((rowNode) =>
              rowNode.data?.['projects']?.some((project: Partial<KPI.Project>) =>
                project.instances?.find((i) => i.scenario?.id === scenario.id && i.status?.is_request),
              ),
            ),
              availableTransitionsIds = this.allowedTransitions
                .filter(t => t.from_status === statusesFromInstanceInScenario[0])
                .map(t => t.to_status); // Available transitions for 'statusFrom'
            let availableStatuses;
            if (Array.isArray(rowNodes[0].data.investments) && rowNodes[0].data.investments.length > 0) {
              availableStatuses = this.initiativeStatuses.filter(status =>
                availableTransitionsIds.includes(status.id),
              );
            } else {
              // if action does not link to an invest, it can be changed to any status
              availableStatuses = this.initiativeStatuses;
            }

            const savingsStartYear = rowNodes[0]?.data?.[`savings_start_year_scenario_${scenario.id}`];
            const currentYear = new Date().getFullYear();
            const shouldDisableClosed = savingsStartYear && savingsStartYear > currentYear;

            return {
              name: scenario.name,
              cssClasses: this.showScenarii ? [`scenario-${scenario.id}`] : [],
              subMenu: availableStatuses.sort((a, b) => a.ordering - b.ordering).map((status) => {

                const blockedByProject = hasPlannedProject && status.hypothesis,
                  blockedByFutureYear = shouldDisableClosed && status.is_closed,
                  singleSelectedDialogContent = this.translate.instant(
                    'By changing the action {actionLabel} to {toActionStatus}, the investment {investLabel} will change to {toInvestStatus} in the current plan',
                    {
                      actionLabel: rowNodes[0]?.data?.['initiative_label'],
                      toActionStatus: status.name,
                      investLabel: rowNodes[0]?.data?.['related_invest'],
                      toInvestStatus: status.name,
                    }
                  ),
                  multipleSelectedDialogContent = this.translate.instant(
                    'By changing the {actionNb} actions to {toActionStatus}, the {investNb} investments will change to {toInvestStatus} in the current plan',
                    {
                      actionNb: rowNodes.length,
                      toActionStatus: status.name,
                      investNb: rowNodes.filter((rowNode) => rowNode?.data?.['related_invest'])?.length,
                      toInvestStatus: status.name,
                    }
                  ),
                  isStatusDisabled = !this.hasInstanceForScenario(rowNodes, scenario.id)
                    || this.isStatusUpdateDisabled(rowNodes, scenario.id, status.id)
                    || !this.areStatusEqualForScenario(rowNodes, scenario.id)
                    || blockedByProject || isSelectedMultipleStatus || blockedByFutureYear

                return {
                  name: status.name,
                  disabled: isStatusDisabled,
                  tooltip: blockedByProject
                    ? this.translate.instant('The action is linked to a planned project, please change the status of the project first')
                    : blockedByFutureYear
                    ? this.translate.instant('Cannot close the item(s) in the future')
                    : '',
                  action: () => {
                    // If main scenario AND any of the selected initiative has an investment which will be impacted by the change,
                    // then display a confirmation dialog, else, directly update the status
                    const obs = (
                      scenario.is_main
                      && status
                      && rowNodes.filter((rowNode) => rowNode?.data?.['related_invest'])?.length
                    ) ? this.dialogService.open(
                      BasicDialogComponent,
                      {
                        autoFocus: false,
                        context: {
                          title: this.translate.instant('Confirmation'),
                          content: isSingleSelect
                            ? singleSelectedDialogContent
                            : multipleSelectedDialogContent,
                        },
                      }
                    ).onClose
                      : of(true);

                    // If the user confirms the change (Or no confirmation is needed), then update the status
                    obs.pipe(
                      filter((confirmation) => !!confirmation)
                    ).subscribe(() => {
                      this.loading = true;
                      const currentStatus = rowNodes[0].data[`initiative_status_scenario_${scenario.id}`];
                      this.initiativesChangesService.updateMultipleInitiativesStatus(
                        initiativeIds,
                        currentStatus,
                        status.id,
                        scenario.id,
                      ).subscribe({
                        next: () => this.gridApi?.refreshServerSide(),
                        error: () => this.loading = false,
                      });
                    });
                  },
                }
              }),
            };
          }),
        });

      if (isSingleSelect) {
        /**
         * Change initiative year
         */
          contextMenu.push(
            {
              name: this.translate.instant('Change year'),
              icon: '<i class="fa-light fa-calendar fa-lg"></i>',
              disabled: !this.customerConfig?.is_show_edit || readOnly,
              subMenu: scenarii.map((scenario) => {
                const areStatusRequestOrHypothesis = rowNodes.every(rowNode => {
                  const statusId = rowNode.data?.instances?.find((instance) => instance.scenario === scenario.id)?.status,
                  status = this.investmentStatuses.find((s) => s.id === statusId);
                  return status?.hypothesis || status?.is_request;
                });
                const fromYear = rowNodes[0]?.data?.[`savings_start_year_scenario_${scenario.id}`];
                const fromDate = rowNodes[0]?.data?.[`savings_start_at_scenario_${scenario.id}`];
                const toYears = R.range(new Date().getFullYear(), 2051);

                return {
                  name: scenario.name,
                  cssClasses: this.showScenarii ? [`scenario-${scenario.id}`] : [],
                  disabled: !areStatusRequestOrHypothesis,
                  subMenu: toYears.map((toYear) => {
                    const newDate = new Date(fromDate);
                    newDate.setFullYear(toYear);
                    const newInstance = {
                      id: rowNodes[0]?.data?.[`instance_id_scenario_${scenario.id}`],
                      savings_start_at: `${toYear}-${newDate.getMonth() + 1}-${newDate.getDate()}`,
                    };
                    return {
                      name: toYear.toString(),
                      disabled: toYear === fromYear,
                      tooltip: toYear === fromYear
                        ? this.translate.instant('The new year must be different from the current one')
                        : '',
                      action: () => {
                        this.changeInitiativeYear(initiativeIds[0], newInstance);
                      },
                    };
                  }),
                };
              }),
            },
            {
              /** Delete initiative */
              name: this.translate.instant('Delete'),
              disabled: readOnly || blockedStatus,
              action: () => {
                this.deleteInitiative(rowNodes);
              }
            }
          );
      }
    }

    return contextMenu;
  }

  // Checks that the new status is available for all selected rows
  private isStatusUpdateDisabled(rowNodes: any[], scenarioId: number, newStatusId: number) {
    return rowNodes.some((row) => {
      const scenario_investment = row?.data?.investments?.find((investment) => investment.scenario === scenarioId);
      const scenario_investment_status = this.investmentStatuses?.find((status) => status.id === scenario_investment?.status);
      const new_initiative_status = this.initiativeStatuses?.find((status) => status.id === newStatusId);
      return scenario_investment // No investment, so no status to check
        && (
          // New status is not a hypothesis, so it can be applied only if the current status allows to unplan the initiative
          ((new_initiative_status?.hypothesis) && !scenario_investment_status?.related_initiative_can_be_unplanned)
        );
    });
  }

  // Checks that all selected rows have the same status for the given scenario
  private areStatusEqualForScenario(rowNodes: any[], scenarioId: number): boolean {
    const status_column = `initiative_status_scenario_${scenarioId}`;
    return rowNodes.every((rowNode) => {
      if (rowNodes[0]?.data && rowNodes[0].data[status_column]) {
        return (
          rowNode.data &&
          rowNode.data[status_column] === rowNodes[0].data[status_column]
        );
      } else {
        return false;
      }
    });
  }

  // Checks that an instance exists for the given scenario in all selected rows
  private hasInstanceForScenario(rowNodes: any[], scenarioId: number) {
    return rowNodes.every((row) => {
      if (row?.data) {
        return !!row.data.instances?.find((instance) => instance.scenario === scenarioId);
      }
      return false;
    });
  }

  private applySortsFromUrl() {
    this.subscriptions.push(
      combineLatest([
        this.route.queryParams,
        this.investmentScenariiService.mainScenario$,
      ]).subscribe(([params, scenario]) => {
        const sortByParam = params['sortBy'];
        if (sortByParam === 'kwh') {
          this.gridApi.applyColumnState({
            state: [{ colId: 'theoretical_savings_full_year', sort: 'desc' }],
            defaultState: { sort: null },
          });
        } else if (sortByParam === 'co2') {
          this.gridApi.applyColumnState({
            state: [{ colId: 'greenhouse_gas_savings_full_year', sort: 'desc' }],
            defaultState: { sort: null },
          });
        } else if (sortByParam === 'year') {
          this.gridApi.applyColumnState({
            state: [{ colId: `savings_start_year_scenario_${scenario.id}`, sort: 'asc' }],
            defaultState: { sort: null },
          });
        }
      })
    )
  }

  private changeInitiativeYear(
    initiativeId: number,
    newInstance: KPI.UpdatableInitiativeInstance,
  ) {
    this.loading = true;
    this.initiativesChangesService.updateInitiativeInstance(
      initiativeId,
      newInstance
    );
  }

  private get yearsToUse$(): Observable<[number, number]> {
    return this.yearsService.latestYears$.pipe(
      map(([start_year, end_year]) => {
        return [
          this.project
            ? new Date(this.project.start_date).getFullYear()
            : start_year,
          this.project
            ? new Date(this.project.end_date).getFullYear()
            : end_year,
        ]
      })
    )
  }

  private openActionForm(actionId: number): void {
    this.subscriptions.push(
      this.initiativesService.getInitiative(Number(actionId)).subscribe((action) =>
        this.rightPanelDialogService.open(
          InitiativeFormComponent,
          {
            autoFocus: false,
            closeOnBackdropClick: false,
            context: {
              initiative: action,
            },
          }
        )
      )
    )
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
  }

  private deleteInitiative(rowNodes: RowNode[]) {
    const selectedInitiatives = rowNodes.map((rowNode) => rowNode.data)
    const initiativeCount = rowNodes.length;
    const content =
      initiativeCount === 1
        ? this.translate.instant("Do you confirm the deletion of the action?")
        : this.translate.instant("Do you confirm that {initiativeCount} initiatives will be deleted ?", {
            initiativeCount: initiativeCount
          });
    const hasInvestments = selectedInitiatives.find(initiativeData => initiativeData.investments?.length > 0);
    const option = hasInvestments ? this.translate.instant("Also delete the linked investment") : "";
    const dialogRef = this.dialogService.open(
      DialogWithCheckboxOptionComponent,
      {
        autoFocus: false,
        context: {
          title: this.translate.instant("Delete action"),
          content: content,
          option: option
        }
      }
    );
    dialogRef.onClose
      .pipe(
        first(),
        filter((data) => !!data.confirmation),
        switchMap((dialogData) =>
          forkJoin(selectedInitiatives.map((initiativeData) =>
            this.initiativesService.deleteInitiative(initiativeData.initiative_id).pipe(
              tap(() => {
                if (dialogData.checked && initiativeData.investments?.length > 0) {
                  const investmentIds = initiativeData.investments.map(invest => invest.id);
                  this.deleteInitiativeInvestments(investmentIds)
                }
              })
            )
          ))
        ),
        finalize(() => this.gridApi?.refreshServerSide())
      )
      .subscribe();
  }

  private deleteInitiativeInvestments(investmentIds: number[]) {
    forkJoin(investmentIds.map((investmentId) => this.investmentsService.deleteInvestment(investmentId)))
    .subscribe();
  }

  private selectNewInitiativeRow() {
    if (this.newInitiative) {
      setTimeout(() => {
        // Due to a bug with the rows numbers (the number 1 is duplicated when a new row gets added
        // in the 1st position), we have to redraw the rows. We do it in a settimout because I prefer
        // to let the "row adding" animation finish.
        this.gridApi.redrawRows();
        const newInitiativeRow = this.gridApi.getRowNode(this.newInitiative.id.toString());
        if (newInitiativeRow) {
          newInitiativeRow.setSelected(true);
        }
        this.newInitiative = null;
      }, 400);
    }
  }
}
